// Copyright (c) 2025 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/timelinemessage/v4/user_timeline_message.proto (package wisetime.user.timelinemessage.v4, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../../../../google/type/date_pb";
import { file_google_type_date } from "../../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/timelinemessage/v4/user_timeline_message.proto.
 */
export const file_wisetime_user_timelinemessage_v4_user_timeline_message: GenFile = /*@__PURE__*/
  fileDesc("Cjx3aXNldGltZS91c2VyL3RpbWVsaW5lbWVzc2FnZS92NC91c2VyX3RpbWVsaW5lX21lc3NhZ2UucHJvdG8SIHdpc2V0aW1lLnVzZXIudGltZWxpbmVtZXNzYWdlLnY0In4KH0xpc3RVc2VyVGltZWxpbmVNZXNzYWdlc1JlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCRIlCgpzdGFydF9kYXRlGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRIjCghlbmRfZGF0ZRgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUidAogTGlzdFVzZXJUaW1lbGluZU1lc3NhZ2VzUmVzcG9uc2USUAoRdGltZWxpbmVfbWVzc2FnZXMYASADKAsyNS53aXNldGltZS51c2VyLnRpbWVsaW5lbWVzc2FnZS52NC5Vc2VyVGltZWxpbmVNZXNzYWdlImQKE1VzZXJUaW1lbGluZU1lc3NhZ2USCgoCaWQYASABKAkSDwoHc2l0ZV9pZBgCIAEoCRIPCgdjb250ZW50GAMgASgJEh8KBGRhdGUYBCABKAsyES5nb29nbGUudHlwZS5EYXRlMsABChpVc2VyVGltZWxpbmVNZXNzYWdlU2VydmljZRKhAQoYTGlzdFVzZXJUaW1lbGluZU1lc3NhZ2VzEkEud2lzZXRpbWUudXNlci50aW1lbGluZW1lc3NhZ2UudjQuTGlzdFVzZXJUaW1lbGluZU1lc3NhZ2VzUmVxdWVzdBpCLndpc2V0aW1lLnVzZXIudGltZWxpbmVtZXNzYWdlLnY0Lkxpc3RVc2VyVGltZWxpbmVNZXNzYWdlc1Jlc3BvbnNlQk0KKGNvbS53aXNldGltZS5hcGkudXNlci50aW1lbGluZW1lc3NhZ2UudjRCH1VzZXJUaW1lbGluZU1lc3NhZ2VTZXJ2aWNlUHJvdG9QAWIGcHJvdG8z", [file_google_type_date]);

/**
 * @generated from message wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest
 */
export type ListUserTimelineMessagesRequest = Message<"wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest"> & {
  /**
   * Site ID for which to list messages.
   *
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * Start date inclusive.
   *
   * @generated from field: google.type.Date start_date = 2;
   */
  startDate?: Date;

  /**
   * End date inclusive.
   *
   * @generated from field: google.type.Date end_date = 3;
   */
  endDate?: Date;
};

/**
 * Describes the message wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.
 * Use `create(ListUserTimelineMessagesRequestSchema)` to create a new message.
 */
export const ListUserTimelineMessagesRequestSchema: GenMessage<ListUserTimelineMessagesRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timelinemessage_v4_user_timeline_message, 0);

/**
 * @generated from message wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse
 */
export type ListUserTimelineMessagesResponse = Message<"wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.timelinemessage.v4.UserTimelineMessage timeline_messages = 1;
   */
  timelineMessages: UserTimelineMessage[];
};

/**
 * Describes the message wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.
 * Use `create(ListUserTimelineMessagesResponseSchema)` to create a new message.
 */
export const ListUserTimelineMessagesResponseSchema: GenMessage<ListUserTimelineMessagesResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timelinemessage_v4_user_timeline_message, 1);

/**
 * @generated from message wisetime.user.timelinemessage.v4.UserTimelineMessage
 */
export type UserTimelineMessage = Message<"wisetime.user.timelinemessage.v4.UserTimelineMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: google.type.Date date = 4;
   */
  date?: Date;
};

/**
 * Describes the message wisetime.user.timelinemessage.v4.UserTimelineMessage.
 * Use `create(UserTimelineMessageSchema)` to create a new message.
 */
export const UserTimelineMessageSchema: GenMessage<UserTimelineMessage> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timelinemessage_v4_user_timeline_message, 2);

/**
 * Service that provides timeline messages for the current user.
 * Timeline messages are managed by the SiteTimelineMessageService.
 *
 * @generated from service wisetime.user.timelinemessage.v4.UserTimelineMessageService
 */
export const UserTimelineMessageService: GenService<{
  /**
   * List all timeline messages for the current user in requested site.
   * If messages are not found the response will contain an empty list.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Request is invalid (start/end dates in wrong range) or site_id is missing
   * - PERMISSION_DENIED: If current user has not access to site or site doesn't not exist
   *
   * @generated from rpc wisetime.user.timelinemessage.v4.UserTimelineMessageService.ListUserTimelineMessages
   */
  listUserTimelineMessages: {
    methodKind: "unary";
    input: typeof ListUserTimelineMessagesRequestSchema;
    output: typeof ListUserTimelineMessagesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_user_timelinemessage_v4_user_timeline_message, 0);

